import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	private readonly TOKEN_KEY = 'app.authToken';
	private readonly THEME_KEY = 'app.theme';

	public getToken(): string | null {
		return localStorage.getItem(this.TOKEN_KEY) || 
			sessionStorage.getItem(this.TOKEN_KEY)
	}

	public setToken(value: string, useLocalStorage): void {
		if (useLocalStorage) {
			localStorage.setItem(this.TOKEN_KEY, value);
		} else {
			sessionStorage.setItem(this.TOKEN_KEY, value);
		}
	}

	public clearToken(): void {
		localStorage.removeItem(this.TOKEN_KEY);
	}

	public getTheme(): string | null {
		return localStorage.getItem(this.THEME_KEY);
	}

	public setTheme(value: string): void {
		localStorage.setItem(this.THEME_KEY, value);
	}

	public clearTheme(): void {
		localStorage.removeItem(this.THEME_KEY);
	}
}
